import { Verdict } from '@exam-management/graphql';
import { z } from 'zod';

export enum QuestionReviewResultVerdict {
  Approved = Verdict.Approved,
  Rejected = Verdict.Rejected,
}

export const QuestionReviewTaskQuestionDetailsFormSchema = z.object({
  result: z.nativeEnum(QuestionReviewResultVerdict, { message: 'กรุณาเลือกผลการทบทวน' }),
  description: z.string().optional(),
});

export type QuestionReviewTaskQuestionDetailsFormValues = z.infer<
  typeof QuestionReviewTaskQuestionDetailsFormSchema
>;
